export default "__VITE_ASSET__CUqsVn5d__"